import { render, staticRenderFns } from "./BillingView.vue?vue&type=template&id=22155606&"
import script from "./BillingView.vue?vue&type=script&lang=js&"
export * from "./BillingView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports